export function downloadImage(url) {
    const a = document.createElement("a");
    a.href = url;
    a.download = "MyOilOnShirt.png";
    a.click();
}